import { FC } from 'react';
import { DeploymentUnitStatus } from '@agilelab/plugin-wb-builder-common';
import { DeploymentStatusBadge } from '../../common';
import { snakeCaseToTitleCase } from '@agilelab/plugin-wb-platform-common';

interface Props {
  status?: DeploymentUnitStatus;
  version?: string;
  disabled?: boolean;
  showVersion?: boolean;
}
// this component is used in the release detail page to show the deployment status of the release and data product in the preview section,
export const DeploymentPreviewChip: FC<Props> = ({
  status,
  version,
  disabled,
}) => {
  return (
    <DeploymentStatusBadge
      status={status}
      version={version}
      disabled={disabled}
      showIcon={false}
      label={snakeCaseToTitleCase(status?.toLowerCase() ?? '-')}
      showVersion={!!version && status !== 'NOT_DEPLOYED'}
    />
  );
};
